export default "__VITE_ASSET__c7938c18__"